/**
 * isSlug tests if a stripped string contains spaces
 * if so, it is not a slug.
 * A slug must however, contain a dash.
 */
export default function isSlug (str) {
  if (!str) {
    return false
  }
  if (str.trim().includes(' ')) {
    return false
  }

  if (!str.includes('-')) {
    return false
  }

  return true
}
